import Popup from "../../components/Popup";
import {connect} from "react-redux";
import React, {useState} from "react";
import {notifyAboutError} from "../../methods/notifyUser";
import PhoneNumberInput from "../../components/PhoneNumberInput";
import {validate} from "../../validate";
import SelectOptionsView from "../Contracts/SelectOptionsView";
import {
    accessChoiceOptions,
} from "../../methods/templatePermissions";

let InviteEmployeePopup: any = function InviteEmployeePopup(props: any) {
    const [invitePhoneNumber, setInvitePhoneNumber] = useState("")
    const [accessChoice, setAccessChoice] = useState("full")
    const accessOptions = accessChoiceOptions(props.accessProfiles || [])

    const selectedAccess = accessOptions.find(
        (option) => option.id === accessChoice
    ) || accessOptions[0]

    return <Popup
        maxWidth="650px"
        onClose={props.onClose}
    >
        <div>
            <div className="centeredLabel">
                <div className="commonLabel" style={{marginTop: "25px", textAlign: "center", whiteSpace: "pre-wrap"}}>
                    Введите номер телефона вашего сотрудника
                </div>
            </div>

            <div style={{ marginTop: "5px" }}>
                <PhoneNumberInput
                    value={invitePhoneNumber}
                    disabled={false}
                    onChange={(value) => {
                        setInvitePhoneNumber(value)
                    }}
                    placeholder="Номер телефона"
                />
            </div>

            <div style={{ marginTop: "16px" }}>
                <div className="commonLabel" style={{marginBottom: "6px"}}>
                    Уровень доступа
                </div>
                <div className="commonSubtitle" style={{marginBottom: "8px"}}>
                    {selectedAccess.description}
                </div>
                <div className="commonSubtitle" style={{marginBottom: "8px"}}>
                    После приглашения сотрудник не увидит шаблоны, пока вы не откроете
                    «Доступ к шаблонам» в карточке сотрудника.
                </div>
                <SelectOptionsView
                    selectedOption={selectedAccess}
                    onSelectOption={(option: any) => {
                        if (option?.id) {
                            setAccessChoice(option.id)
                        }
                    }}
                    options={accessOptions}
                    placeholder="Уровень доступа"
                    freeSolo={false}
                    width="full"
                    popperZIndex={4000}
                />
            </div>

            <hr className="newHR"/>

            <div className="buttonsContainer" style={{width: "100%"}}>
                <button
                    className="new withTitle _wa"
                    onClick={(e) => {
                        try {
                            let error = validate('phoneNumber', invitePhoneNumber, 'Номер телефона')
                            if (error) {
                                throw new Error("Неправильный номер телефона")
                            }
                            props.invite(invitePhoneNumber, accessChoice)
                        } catch (error) {
                            notifyAboutError(props, error)
                        }
                    }}
                >
                    Пригласить
                </button>
                <button
                    className="new withTitle secondary _wa"
                    onClick={(e) => {
                        props.onClose()
                    }}
                >
                    Отмена
                </button>
            </div>
        </div>
    </Popup>
}

InviteEmployeePopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(InviteEmployeePopup)

export default InviteEmployeePopup
